import Notify from './notifyActions'
import {
  GET_DASHBOARD_OVERVIEW,
  GET_DASHBOARD_ORGANISATIONS,
  GET_DASHBOARD_SUBSCRIPTIONS,
  GET_SUBSCRIPTION_DETAILS,
  GET_PLUS_FEATURES_CONFIG,
  UPDATE_PLUS_FEATURES_CONFIG,
  GET_JOB_LOGS,
  GET_JOB_LOG_DETAILS
} from "../reducers/dashboardReducer"
import type { ReduxAxiosAction } from './common'

export const DASHBOARD_LOAD_FAIL_TOAST = 'error_loading_dashboard'

/** @deprecated Use ReduxAxiosAction from common.ts instead */
type DashboardAction = ReduxAxiosAction

export const getDashboardOverview = (): DashboardAction => {
  return {
    type: GET_DASHBOARD_OVERVIEW,
    payload: {
      request: {
        mode: 'no-cors',
        url: `dashboard/overview`,
        method: 'GET'
      }
    }
  }
}

export const getDashboardOrganisations = (pageNumber: number = 1, pageSize: number = 10, search: string = ''): DashboardAction => {
  const searchQuery = search && search.trim() ? `&search=${encodeURIComponent(search.trim())}` : ''

  return {
    type: GET_DASHBOARD_ORGANISATIONS,
    payload: {
      request: {
        mode: 'no-cors',
        url: `dashboard/organisations?pageNumber=${pageNumber}&pageSize=${pageSize}${searchQuery}`,
        method: 'GET'
      }
    }
  }
}

export const getDashboardSubscriptions = (pageNumber: number = 1, pageSize: number = 10, search: string = ''): DashboardAction => {
  const searchQuery = search && search.trim() ? `&search=${encodeURIComponent(search.trim())}` : ''

  return {
    type: GET_DASHBOARD_SUBSCRIPTIONS,
    payload: {
      request: {
        mode: 'no-cors',
        url: `dashboard/subscriptions?pageNumber=${pageNumber}&pageSize=${pageSize}${searchQuery}`,
        method: 'GET'
      }
    }
  }
}

export const getSubscriptionDetails = (subscriptionId: string | number): DashboardAction => {
  return {
    type: GET_SUBSCRIPTION_DETAILS,
    payload: {
      request: {
        mode: 'no-cors',
        url: `dashboard/subscriptions/${subscriptionId}`,
        method: 'GET'
      }
    }
  }
}

/**
 * @deprecated UNUSED — No component dispatches this action.
 * Feature configuration is managed via subscription-management instead.
 * Get Plus Features configuration for subscription upgrade dialog
 */
export const getPlusFeaturesConfig = (): DashboardAction => {
  return {
    type: GET_PLUS_FEATURES_CONFIG,
    payload: {
      request: {
        mode: 'no-cors',
        url: `dashboard/plus-features-config`,
        method: 'GET'
      }
    }
  }
}

/**
 * @deprecated UNUSED — No component dispatches this action.
 * Feature configuration is managed via subscription-management instead.
 * Update Plus Features configuration
 */
export const updatePlusFeaturesConfig = (enabledFeatures: any[]): DashboardAction => {
  return {
    type: UPDATE_PLUS_FEATURES_CONFIG,
    payload: {
      request: {
        mode: 'no-cors',
        url: `dashboard/plus-features-config`,
        method: 'POST',
        data: {
          enabledFeatures: enabledFeatures
        }
      }
    }
  }
}

/**
 * Get paginated background job logs
 */
export const getJobLogs = (pageNumber: number = 1, pageSize: number = 20, jobType: string | null = null): DashboardAction => {
  let url = `dashboard/job-logs?pageNumber=${pageNumber}&pageSize=${pageSize}`
  if (jobType !== null && jobType !== undefined) {
    url += `&jobType=${jobType}`
  }
  return {
    type: GET_JOB_LOGS,
    payload: {
      request: {
        mode: 'no-cors',
        url: url,
        method: 'GET'
      }
    }
  }
}

/**
 * Get detailed job log by ID
 */
export const getJobLogDetails = (jobLogId: string | number): DashboardAction => {
  return {
    type: GET_JOB_LOG_DETAILS,
    payload: {
      request: {
        mode: 'no-cors',
        url: `dashboard/job-logs/${jobLogId}`,
        method: 'GET'
      }
    }
  }
}
